export interface Movie {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  poster: string;
  rating: number;
  year: number;
  duration: string;
  description: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  views: number;
  director: string;
  actors: string[];
  region: string;
}

export const movies: Movie[] = [
  {
    id: 'movie-1',
    title: '暗夜追踪',
    category: '动作',
    categorySlug: 'action',
    poster: 'https://readdy.ai/api/search-image?query=Dark%20noir%20action%20movie%20poster%20with%20a%20lone%20figure%20in%20trench%20coat%20walking%20through%20rainy%20neon-lit%20city%20streets%20at%20night%2C%20cinematic%20lighting%2C%20film%20grain%20texture%2C%20dramatic%20shadows%2C%20warm%20gold%20and%20deep%20crimson%20accents%2C%20movie%20poster%20composition&width=600&height=800&seq=movie-poster-01&orientation=portrait',
    rating: 8.7,
    year: 2025,
    duration: '128分钟',
    description: '在夜幕降临的城市里，一位退役特种兵为追查真相，深入地下犯罪世界。每一帧都充满紧张刺激的动作场面，让你彻夜难眠的悬疑大作。',
    tags: ['警匪', '悬疑', '动作大片', '高评分'],
    isHot: true,
    isNew: false,
    views: 1258000,
    director: '陈凯歌',
    actors: ['刘德华', '周迅', '王千源'],
    region: '中国大陆'
  },
  {
    id: 'movie-2',
    title: '午夜巴黎奇缘',
    category: '爱情',
    categorySlug: 'romance',
    poster: 'https://readdy.ai/api/search-image?query=Romantic%20movie%20poster%20of%20a%20couple%20embracing%20under%20warm%20street%20lamps%20in%20Paris%20at%20midnight%2C%20soft%20golden%20lighting%2C%20cobblestone%20streets%2C%20cinematic%20film%20look%2C%20dreamy%20atmosphere%2C%20warm%20amber%20tones%2C%20elegant%20composition&width=600&height=800&seq=movie-poster-02&orientation=portrait',
    rating: 8.2,
    year: 2025,
    duration: '115分钟',
    description: '两个失眠的灵魂在午夜巴黎的街头偶遇，从陌生人到知己，一段浪漫又治愈的都市爱情故事。',
    tags: ['浪漫', '都市', '治愈', '法国取景'],
    isHot: true,
    isNew: true,
    views: 892000,
    director: '王家卫',
    actors: ['梁朝伟', '汤唯', '张震'],
    region: '中国香港'
  },
  {
    id: 'movie-3',
    title: '笑傲江湖之夜里挑灯',
    category: '喜剧',
    categorySlug: 'comedy',
    poster: 'https://readdy.ai/api/search-image?query=Comedy%20martial%20arts%20movie%20poster%20with%20a%20cheerful%20warrior%20holding%20a%20lantern%20in%20ancient%20Chinese%20setting%20at%20night%2C%20warm%20golden%20lantern%20light%2C%20humorous%20expression%2C%20vibrant%20colors%2C%20Chinese%20calligraphy%20title%20design&width=600&height=800&seq=movie-poster-03&orientation=portrait',
    rating: 8.9,
    year: 2024,
    duration: '142分钟',
    description: '笑中带泪的武侠喜剧，一位不靠谱的江湖小人物阴差阳错成为大侠，夜夜挑灯苦练武功，笑料百出。',
    tags: ['武侠', '喜剧', '古装', '合家欢'],
    isHot: true,
    isNew: false,
    views: 2100000,
    director: '宁浩',
    actors: ['沈腾', '马丽', '艾伦'],
    region: '中国大陆'
  },
  {
    id: 'movie-4',
    title: '星域迷航：黑暗纪元',
    category: '科幻',
    categorySlug: 'scifi',
    poster: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20with%20a%20massive%20spaceship%20floating%20in%20deep%20space%20surrounded%20by%20nebula%20clouds%2C%20stars%20twinkling%2C%20dark%20cosmic%20background%2C%20warm%20golden%20nebula%20accents%2C%20cinematic%20wide%20composition&width=600&height=800&seq=movie-poster-04&orientation=portrait',
    rating: 9.1,
    year: 2026,
    duration: '156分钟',
    description: '人类文明在星际探索中遭遇未知文明，一场关乎存亡的太空史诗拉开帷幕。视觉效果震撼，剧情层层反转。',
    tags: ['太空', '史诗', '视觉盛宴', 'IMAX'],
    isHot: true,
    isNew: true,
    views: 3500000,
    director: '郭帆',
    actors: ['吴京', '刘昊然', '李雪健'],
    region: '中国大陆'
  },
  {
    id: 'movie-5',
    title: '幽灵公寓309',
    category: '恐怖',
    categorySlug: 'horror',
    poster: 'https://readdy.ai/api/search-image?query=Horror%20movie%20poster%20of%20a%20dimly%20lit%20apartment%20door%20with%20number%20309%2C%20eerie%20warm%20light%20seeping%20from%20under%20the%20door%2C%20shadowy%20figure%20in%20background%2C%20atmospheric%20dread%2C%20dark%20cinematic%20horror%20aesthetic&width=600&height=800&seq=movie-poster-05&orientation=portrait',
    rating: 7.8,
    year: 2025,
    duration: '98分钟',
    description: '搬进廉价公寓的年轻情侣，深夜总能听到隔壁传来奇怪的敲墙声。但物业说，309室已经空置三年了...',
    tags: ['心理恐怖', '都市传说', '悬疑', '烧脑'],
    isHot: false,
    isNew: true,
    views: 543000,
    director: '温子仁',
    actors: ['张子枫', '彭于晏', '舒淇'],
    region: '中国台湾'
  },
  {
    id: 'movie-6',
    title: '月光龙骑士',
    category: '动画',
    categorySlug: 'animation',
    poster: 'https://readdy.ai/api/search-image?query=Animated%20fantasy%20movie%20poster%20with%20a%20young%20dragon%20rider%20silhouetted%20against%20a%20giant%20full%20moon%2C%20colorful%20magical%20particles%2C%20warm%20golden%20moonlight%2C%20dreamy%20night%20sky%2C%20anime-inspired%20art%20style&width=600&height=800&seq=movie-poster-06&orientation=portrait',
    rating: 8.5,
    year: 2025,
    duration: '105分钟',
    description: '在月光下与龙共舞的少年，为了守护家园踏上冒险之旅。国漫巅峰之作，画面美到每一帧都能做壁纸。',
    tags: ['奇幻', '冒险', '国漫', '全年龄'],
    isHot: true,
    isNew: false,
    views: 1890000,
    director: '饺子',
    actors: ['杨天翔', '季冠霖', '边江'],
    region: '中国大陆'
  },
  {
    id: 'movie-7',
    title: '密室逃脱：死亡倒计时',
    category: '悬疑',
    categorySlug: 'suspense',
    poster: 'https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20poster%20with%20an%20antique%20hourglass%20on%20a%20dark%20wooden%20table%2C%20sand%20running%20out%2C%20mysterious%20locked%20room%20in%20background%2C%20warm%20candlelight%2C%20tense%20atmosphere%2C%20film%20noir%20style&width=600&height=800&seq=movie-poster-07&orientation=portrait',
    rating: 8.3,
    year: 2024,
    duration: '110分钟',
    description: '六个陌生人被困密室，每隔一小时就有一人"出局"。谁是幕后黑手？层层推理，结局让你大呼过瘾。',
    tags: ['推理', '密室', '心理战', '高分悬疑'],
    isHot: false,
    isNew: false,
    views: 976000,
    director: '陈思诚',
    actors: ['刘昊然', '王宝强', '肖央'],
    region: '中国大陆'
  },
  {
    id: 'movie-8',
    title: '战火黎明的约定',
    category: '战争',
    categorySlug: 'war',
    poster: 'https://readdy.ai/api/search-image?query=War%20drama%20movie%20poster%20with%20soldiers%20silhouetted%20against%20a%20burning%20dawn%20sky%2C%20smoke%20and%20embers%2C%20warm%20orange%20and%20crimson%20tones%2C%20poignant%20cinematic%20composition%2C%20emotional%20war%20film%20aesthetic&width=600&height=800&seq=movie-poster-08&orientation=portrait',
    rating: 9.0,
    year: 2025,
    duration: '148分钟',
    description: '战火纷飞的年代，一群普通的中国军人用生命坚守阵地，等待黎明到来。真实历史改编，热血催泪。',
    tags: ['历史', '战争', '爱国', '催泪'],
    isHot: false,
    isNew: true,
    views: 1680000,
    director: '张艺谋',
    actors: ['张译', '吴京', '易烊千玺'],
    region: '中国大陆'
  },
  {
    id: 'movie-9',
    title: '深夜食堂：人生一串',
    category: '喜剧',
    categorySlug: 'comedy',
    poster: 'https://readdy.ai/api/search-image?query=Warm%20food%20movie%20poster%20showing%20a%20cozy%20night%20street%20food%20stall%20with%20steaming%20skewers%2C%20warm%20golden%20lights%2C%20friendly%20chef%20smiling%2C%20late%20night%20atmosphere%2C%20comforting%20cinematic%20style&width=600&height=800&seq=movie-poster-09&orientation=portrait',
    rating: 8.1,
    year: 2024,
    duration: '102分钟',
    description: '深夜的路边烧烤摊，各色人物来来往往，一串烧烤一段人生。温暖治愈，看饿了别怪我。',
    tags: ['美食', '治愈', '都市', '温情'],
    isHot: false,
    isNew: false,
    views: 756000,
    director: '韩寒',
    actors: ['黄渤', '徐峥', '王传君'],
    region: '中国大陆'
  },
  {
    id: 'movie-10',
    title: '失控玩家：虚拟逃亡',
    category: '科幻',
    categorySlug: 'scifi',
    poster: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20poster%20with%20a%20digital%20avatar%20breaking%20through%20pixelated%20glass%2C%20neon%20circuit%20patterns%2C%20warm%20amber%20and%20electric%20crimson%20highlights%2C%20cyberpunk%20aesthetic%2C%20cinematic&width=600&height=800&seq=movie-poster-10&orientation=portrait',
    rating: 8.6,
    year: 2026,
    duration: '132分钟',
    description: '一个游戏NPC突然觉醒自我意识，在虚拟世界中掀起一场轰轰烈烈的革命。脑洞大开，笑点密集。',
    tags: ['科幻', '喜剧', '游戏', '脑洞'],
    isHot: true,
    isNew: true,
    views: 2900000,
    director: '路阳',
    actors: ['雷佳音', '杨幂', '董子健'],
    region: '中国大陆'
  },
  {
    id: 'movie-11',
    title: '彼岸花开时',
    category: '爱情',
    categorySlug: 'romance',
    poster: 'https://readdy.ai/api/search-image?query=Poetic%20romance%20movie%20poster%20with%20red%20spider%20lilies%20blooming%20along%20a%20misty%20riverbank%20at%20twilight%2C%20two%20distant%20figures%2C%20warm%20crimson%20and%20golden%20tones%2C%20dreamy%20cinematic%20composition&width=600&height=800&seq=movie-poster-11&orientation=portrait',
    rating: 8.4,
    year: 2025,
    duration: '118分钟',
    description: '一段跨越十年的异地恋，两颗心在彼岸花开的季节再次相遇。每个人都能在电影里找到自己的影子。',
    tags: ['青春', '异地恋', '文艺', '催泪'],
    isHot: false,
    isNew: false,
    views: 634000,
    director: '曾国祥',
    actors: ['周冬雨', '易烊千玺', '刘浩存'],
    region: '中国大陆'
  },
  {
    id: 'movie-12',
    title: '霓虹深渊',
    category: '动作',
    categorySlug: 'action',
    poster: 'https://readdy.ai/api/search-image?query=Cyberpunk%20action%20movie%20poster%20with%20a%20lone%20fighter%20standing%20on%20a%20rooftop%20overlooking%20a%20neon-drenched%20futuristic%20city%20at%20night%2C%20warm%20gold%20and%20crimson%20neon%20lights%2C%20rain%2C%20cinematic&width=600&height=800&seq=movie-poster-12&orientation=portrait',
    rating: 8.0,
    year: 2025,
    duration: '125分钟',
    description: '近未来赛博朋克都市，一位女战士独自对抗整个腐败系统。动作设计堪称一绝，每一场打斗都让人热血沸腾。',
    tags: ['赛博朋克', '女性主角', '动作', '近未来'],
    isHot: false,
    isNew: true,
    views: 1120000,
    director: '林超贤',
    actors: ['舒淇', '张震', '李治廷'],
    region: '中国香港'
  },
];

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '动作', slug: 'action' },
  { name: '喜剧', slug: 'comedy' },
  { name: '爱情', slug: 'romance' },
  { name: '科幻', slug: 'scifi' },
  { name: '恐怖', slug: 'horror' },
  { name: '动画', slug: 'animation' },
  { name: '悬疑', slug: 'suspense' },
  { name: '战争', slug: 'war' },
];

export const hotRankings = [
  { rank: 1, movieId: 'movie-4', change: 'up' },
  { rank: 2, movieId: 'movie-10', change: 'up' },
  { rank: 3, movieId: 'movie-3', change: 'down' },
  { rank: 4, movieId: 'movie-6', change: 'up' },
  { rank: 5, movieId: 'movie-8', change: 'new' },
  { rank: 6, movieId: 'movie-1', change: 'down' },
  { rank: 7, movieId: 'movie-7', change: 'down' },
  { rank: 8, movieId: 'movie-12', change: 'new' },
];

export const heroMovies = ['movie-4', 'movie-1', 'movie-10'];